const TagDefinitionsList = () => import('@/domain/tagDefinitions/TagDefinitionsList.vue')
const TagDefinitionsEdit = () => import('@/domain/tagDefinitions/TagDefinitionsEdit.vue')

export default [
    {
        path: 'tag-definitions',
        redirect: 'tag-definitions',
        name: 'tagDefinitions',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        meta: {
            label: 'Tag Definitions',
            title: 'Tag Definitions',
            breadcrumb: {
                to: { name: 'tagDefinitions.list' },
                text: 'Tag Definitions'
            }
        },
        children: [
            {
                path: '',
                name: 'tagDefinitions.list',
                component: TagDefinitionsList,
                meta: {
                    title: 'Tag Definitions',
                    label: 'Tag Definitions',
                },
            },
            {
                path: 'create',
                name: 'tagDefinitions.create',
                component: TagDefinitionsEdit,
                meta: {
                    title: 'Create Tag Definition',
                    label: 'Create Tag Definition',
                    breadcrumb: {
                        text: 'Create'
                    }
                },
            },
            {
                path: ':id/edit',
                name: 'tagDefinitions.edit',
                component: TagDefinitionsEdit,
                meta: {
                    title: 'Edit Tag Definition',
                    label: 'Edit Tag Definition',
                    breadcrumb: (context) => {
                        const store = context.store
                        const currentTag = store.getters['tagDefinitions/currentTag']
                        return {
                            text: currentTag ? `Edit: ${currentTag.name}` : 'Edit'
                        }
                    }
                },
            },
        ]
    },
]
